import BaseModel from '../vendor/baseModel'
import moment from 'moment'

export class Product extends BaseModel {
  constructor() {
    super({
      name: 'product',
      url: 'products',
      page_size: 'all'
    })
    this.menu = null
  }

  loadList(params = {}, outletId = undefined) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/${this.url}/menu/`, { outlet: outletId }, params)
        .then(response => {
          const results = response.data.menu
          this.menu = results
          resolve(results)
        })
        .catch(() => {
          reject()
        })
    })
  }

  filterByPromo(promo) {
    const productIds = promo.products.map(e => e.id)
    return this.menu.filter(g => {
      return g.products.findIndex(p => productIds.indexOf(p.id) > -1) > -1
    })
  }

  getOneIngredientPrice(ingredient) {
    const getDate = str => {
      const times = str.split(':')
      return moment().hour(times[0]).minute(times[1]).second(times[2])
    }

    const timePrice = ingredient.prices.find(price => {
      if (!price.start_at || !price.end_at) {
        return null
      }
      const startAt = getDate(price.start_at)
      const endAt = getDate(price.end_at)
      const timeNow = moment()
      return timeNow.isSameOrAfter(startAt) && timeNow.isSameOrBefore(endAt)
    })
    if (timePrice) {
      return timePrice.price
    }

    const defaultPrice = ingredient.prices.find(price => {
      return !price.start_at && !price.end_at
    })
    if (defaultPrice) {
      return defaultPrice.price
    }

    return 0
  }

  countTotalPrice(productIngredients, amount) {
    const totalPrice = productIngredients.reduce((acc, val) => {
      const price = this.getOneIngredientPrice(val.ingredient)
      acc += price
      return acc
    }, 0)
    return totalPrice * amount
  }

  getDefaultIngredients(product = null) {
    product = product || this.item
    let list = []
    const requiredIngredientGroups = product.product_ingredient_groups.filter(e => e.min_amount > 0)
    const showIfSelected = product.product_ingredient_groups.filter(
      val => val.show_when_ingredient_selected
    )
    for (let productIngredientGroup of requiredIngredientGroups) {
      const defaultProductIngredients = productIngredientGroup.ingredients.filter(
        e => e.default_amount > 0
      )
      for (let defaultProductIngredient of defaultProductIngredients) {
        const amount = defaultProductIngredient.default_amount
        for (let i = 0; i < amount; i++) {
          list.push(defaultProductIngredient)
        }
      }
    }
    const selectedIngredients = list.map(val => val.ingredient.id)
    showIfSelected.forEach(val => {
      if (selectedIngredients.indexOf(val.show_when_ingredient_selected) === -1) {
        const currentIngredients = val.ingredients.map(v => v.ingredient.id)
        list = list.filter(v => currentIngredients.indexOf(v.ingredient.id) === -1)
      }
    })
    return list
  }
}
